import { ortto_communication } from '@axo/shared/data-access/types';

const time = (value: string) => new Date(value).getTime();

/**
 * The mute that applies to this application, if any: the newest
 * stop-transactional-communication record for the application's market,
 * created at or after the application itself. The backend mutes per customer
 * and market, so an application created after the mute has none (MV-3323 C6).
 */
export const findSessionMute = (
  records: ortto_communication.OrttoCommunication[] | undefined,
  {
    country,
    applicationCreatedAt,
  }: { country: string | undefined; applicationCreatedAt: string | undefined }
): ortto_communication.OrttoCommunication | undefined => {
  if (!country || !applicationCreatedAt) return undefined;
  const since = time(applicationCreatedAt);

  return records
    ?.filter(
      (record) =>
        record.Type === ortto_communication.STOP_TRANSACTION_COMMUNICATION &&
        record.Country === country &&
        time(record.CreatedAt) >= since
    )
    .sort((a, b) => time(b.CreatedAt) - time(a.CreatedAt))[0];
};
